import { createAuthClient } from "better-auth/react";
import { api } from "./client";

export const authClient = createAuthClient({
	baseURL: typeof window !== "undefined" ? window.location.origin : "",
	basePath: "/api/auth",
});

export type CurrentUser = {
	id: string;
	email: string;
	name: string;
	image: string | null;
	emailVerified: boolean;
	isAdmin: boolean;
};

export const authApi = {
	me: () => api.get<{ user: CurrentUser | null }>("/me"),
};
